import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
    <g fill="none" fill-rule="evenodd" transform="translate(1.421 1.612)">
        <path fill="#E8E8E8" fill-rule="nonzero" d="M47.471 19.484l-18.27 19.853-9.755-8.393-3.21 3.768L27.83 44.69l1.812 1.585 1.63-1.767 19.874-21.62z"/>
        <circle cx="33.286" cy="33.286" r="33.286" stroke="#E8E8E8" stroke-width="2"/>
    </g>
  </svg>
)